var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.638,
    height: 36.638,
    viewBox: "0 0 36.638 36.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "status",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M17.756,3.068,10.794,10.03a8.474,8.474,0,0,1,1.612,3.949,1.8,1.8,0,0,1,.423-.068H22a1.8,1.8,0,0,1,.246.04A18.246,18.246,0,0,0,17.756,3.068Z",
    transform: "translate(14.89 3.715)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M.5,18.849A18.343,18.343,0,0,0,17.665,37.138a1.817,1.817,0,0,1-.04-.246V27.718a1.817,1.817,0,0,1,.068-.423,8.541,8.541,0,1,1,6.26-15.281l6.962-6.962A18.327,18.327,0,0,0,.5,18.849Z",
    transform: "translate(0 0)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M25.36,8.54H16.185a1.8,1.8,0,0,1-.423-.068,8.526,8.526,0,0,1-7.291,7.291,1.817,1.817,0,0,1,.068.423V25.36a1.817,1.817,0,0,1-.04.246A18.33,18.33,0,0,0,25.606,8.5a1.8,1.8,0,0,1-.246.04Z",
    transform: "translate(11.532 11.532)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/status_icon.07e679e5719949b80abc976cea007d23.svg";
export { ForwardRef as ReactComponent };